import DesktopCalendar from '@/containers/Desktop/DesktopCalendar';
import React from 'react';
import CalendarFareInMonth from './CalendarFareInMonth';

function Section03(props: any) {
  const {
    onSearchFlight, selectedDate, dayPriceObjStatictis,
    isDesktop, isLoading,
  } = props;

  if (isDesktop) {
    return (
      <DesktopCalendar
        isLoading={isLoading}
        isDisableRoundTrip
        type="depart"
        dayPriceObj={dayPriceObjStatictis}
        selectedDate={{
          depart: new Date(selectedDate),
          return: null,
        }}
        setSelectedDateFunc={onSearchFlight}
      />
    );
  }
  return (
    <CalendarFareInMonth
      dayPriceObj={dayPriceObjStatictis}
      selectedDate={selectedDate}
      onSearchFlight={onSearchFlight}
    />
  );
}

export default React.memo(Section03);
